import React, { useEffect, useRef, useState, useContext } from "react";
import "./styles.css";
import { Title, Breadcrumb, PopUpModal, CustomPopUpModal } from "../../Components/Atoms";
import { Button, Spinner, Switch, Tooltip } from "@chakra-ui/react";
import PATH from "../../Routes/paths";
import { useNavigate } from "react-router-dom";
import { LockIcon, UnlockIcon, EditModelIcon, Alert, PendingClockIcon, } from "../../Assets/images/svgs";
import { activateDeviceSim, getDeviceSimStatus, updatePingTestStatus, getSpecificDevDetails, saveRelayTestStatus, UnsetPingTestStatus, getDriverOrVehicleStats } from "../../APIs";
import { DEVICE_TYPES_VALS, PING_TEST_STATUS, PING_TEST_STATUS_VAL, RELAY_STATES, SELLER_DES, SPN_IDS, SUBDEALERS_DES, PING_TEST_STEPS, IGNITION_STATE, GSM_SIGNAL_LEVELS, UNSET_REASON_KEY, DEVICE_HWTYPS } from "../../Library/constants";
import { getLocalisedDate } from "../../Library/datetime";
import PATHS from "../../Routes/paths";
import LastOrder from "../../Widgets/LastOrder";
import PingTest from "./PingTest";
import { AuthContext, StoreContext } from "../../Library/contexts";
import { TodayRide } from "../../Components/Organisms";
const PINGTEST_TIMEOUT_DURATION = (1000 * 30);
const TWO_MINS_MS = (1000 * 60 * 2);

const SpecificDeviceNew = () => {
  const navigate = useNavigate();
  const [popUpModal, setPopUpModal] = useState(null);
  const [customModal, setCustomModal] = useState(null);
  const [devAndVehicleDetails, setDevAndVehicleDetails] = useState({});
  const [relayState, setRelayState] = useState(0);
  const [relayLoading, setRelayLoading] = useState(false);
  const [relayError, setRelayError] = useState("");
  const [wsConnected, setWsConnected] = useState(false);
  const testStatus = useRef({ lock: false, unlock: false });
  const [pingTestProps, setPingTestProps] = useState({});
  const [enableRelayRetry, setEnableRelayRetry] = useState(false);
  const [circularProgress, setCircularProgress] = useState(0);
  const [vehicleStats, setVehicleStats] = useState([]);
  const { profile } = useContext(AuthContext);
  const { filters, isLiveTrackingEnabled } = useContext(StoreContext);

  const searchParams = new URLSearchParams(window.location.search);
  const ImeiRef = useRef(searchParams.get("imei"));
  const dealerId = useRef(searchParams.get("idx"));
  const instock = useRef(searchParams.get("inStock"));
  const installed = useRef(searchParams.get("installed"));
  const showButtons = useRef(searchParams.get("showButtons"));
  const isRelayLoading = useRef(false);
  const relayHash = useRef(false);
  const liveTracking = useRef(searchParams.get("liveTracking") === "true");
  const isDm = useRef(searchParams.get("isDm") === "true");
  const subscriptionExpiry = useRef(searchParams.get("sed"));

  const updatedImei = searchParams.get("imei");
  const devAndVehDetails = useRef({});
  const currentStateRef = useRef(-1);
  const isRelayTest = useRef(false);
  const isIgnitionTest = useRef(false);
  const RELAY_TEST_STEPS_MAP = useRef({});
  const timeouts = useRef([]);
  const internalRelayTestStarted = useRef(false);
  const internalRelayTestCounter = useRef(0);
  const unlockViaStatusCheck = useRef(false);
  const isRelayTestCompleted = useRef(false);
  const relayRetryCounter = useRef(0);
  const ignoreRelayResponse = useRef(false);
  const isSubscribed = useRef(false);
  const isPostMappingLockReq = useRef(false);
  const simActivationPollRef = useRef(null);
  const simActivationInProgress = useRef(false);

  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
  let SHOW_RELAY_CONTROL_BTN = window.localStorage.getItem("relayControl");
  if (SHOW_RELAY_CONTROL_BTN) {
    try {
      SHOW_RELAY_CONTROL_BTN = JSON.parse(SHOW_RELAY_CONTROL_BTN);
    } catch (e) {
      if (e) SHOW_RELAY_CONTROL_BTN = false;
    }
  }

  const getLink = () => {
    if (isDm.current) return PATHS.SHOW_DEALERS;
    else if (liveTracking.current) return PATH.LIVE_TRACKING;
    else if (DESIGNATION === SUBDEALERS_DES) {
      return PATH.INVENTORY_OVERVIEW;
    }
    else {
      let url = `${PATH.SHOW_DEALERS}/${PATH.DEVICES}?idx=${dealerId.current}`
      if (instock.current) url += `&inStock=true`;
      if (installed.current) url += `&installed=true`;
      return url;
    }
  }

  const getPaths = () => {
    if (isDm.current && DESIGNATION === SELLER_DES) {
      return [
        { idx: 1, name: liveTracking.current ? "Live Tracking" : DESIGNATION === SUBDEALERS_DES ? "Inventory Management" : "Dealer Management", link: getLink() },
        { idx: 2, name: devAndVehicleDetails.dnm, link: `${PATH.SHOW_DEALERS}/${PATH.SPECIFIC_DEALER}?idx=${dealerId.current}` },
        { idx: 3, name: instock.current && installed.current ? "All Devices" : installed.current ? "Devices Mapped" : "Devices Not Mapped", link: `${PATH.SHOW_DEALERS}/${PATH.DEVICES}?idx=${dealerId.current}${instock.current && installed.current ? "&inStock=true&installed=true" : instock.current ? "&inStock=true" : "&installed=true"}&dnm=${devAndVehicleDetails.dnm}` },
        { idx: 4, name: isDm ? ImeiRef.current : "Device Details", isCurrentPage: true, },
      ];
    }
    if (isDm.current && DESIGNATION === SUBDEALERS_DES) {
      return [
        { idx: 1, name: liveTracking.current ? "Live Tracking" : DESIGNATION === SUBDEALERS_DES ? "Inventory Management" : "Dealer Management", link: getLink() },
        { idx: 2, name: instock.current && installed.current ? "All Devices" : installed.current ? "Devices Mapped" : "Devices Not Mapped", link: `${PATH.INVENTORY_OVERVIEW}/${PATH.DEVICES}?idx=${dealerId.current}${instock.current && installed.current ? "&inStock=true&installed=true" : instock.current ? "&inStock=true" : "&installed=true"}&dnm=${devAndVehicleDetails.dnm}` },
        { idx: 3, name: isDm ? ImeiRef.current : "Device Details", isCurrentPage: true, },
      ];
    }
    else return [
      { idx: 1, name: liveTracking.current ? "Live Tracking" : DESIGNATION === SUBDEALERS_DES ? "Inventory Management" : "Dealer Management", link: getLink() },
      { idx: 2, name: "Device Details", isCurrentPage: true },
    ];
  }

  const handleLockUnlockTest = (currentState) => {
    if (profile.oldRelayFlow) setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Make sure you are in good network area" });
    setCustomModal(null);
    if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, command: `RELAY,${currentState ? RELAY_STATES.UNLOCKED : RELAY_STATES.LOCKED}#` } });
  }

  const unsubscribeAndCloseModal = (relayState) => {
    saveRelayTestStatus({ imei: ImeiRef.current, rlyResp: relayState ? RELAY_STATES.LOCKED : RELAY_STATES.UNLOCKED }, (err) => {
      if (err) console.error(err);
      else {
        isRelayTestCompleted.current = true;
        window.localStorage.removeItem(UNSET_REASON_KEY);
        setDevAndVehicleDetails({ ...devAndVehDetails.current, installationDetails: { ...devAndVehDetails.current.installationDetails, relayStat: relayState ? RELAY_STATES.UNLOCKED : RELAY_STATES.LOCKED, relayTs: Date.now() } });
      }
    });
    if (global.WS && global.WS.wsConnected) {
      global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current } });
      isSubscribed.current = false;
    }
    clearAllTimeouts();
    setPingTestProps({});
    setCustomModal(null);
  }

  const handleRelayToggle = (state, unlock) => {
    if ((state && unlock) || (!state && !unlock)) handleLockUnlockTest(state);
  };

  const requestRelayToggle = (currentState) => {
    isPostMappingLockReq.current = true;
    setPopUpModal({ open: false })
    setCustomModal({
      open: true,
      modalBody: (
        <div>
          <Spinner size={"lg"} />
          <p className="relay-modal-message">This vehicle is getting {currentState ? "Unlocked" : "Locked"}</p>
          <p className="relay-modal-note">It might take upto a minute</p>
        </div>
      ),
      onModalClose: () => { },
    });

    if (isLiveTrackingEnabled) {
      if (global.UWS && global.UWS.wsConnected) global.UWS.sendRequest({ action: global.EE.EVENT_TYPES.RELAY, data: { idx: devAndVehicleDetails.did, state: currentState ? RELAY_STATES.UNLOCKED : RELAY_STATES.LOCKED } });
    } else {
      if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, isMapped: !!devAndVehDetails.current.dm, command: `RELAY,${currentState ? RELAY_STATES.UNLOCKED : RELAY_STATES.LOCKED}#` } });
    }
  }

  const handleConfirmModal = (state) => {
    setPopUpModal({
      open: true,
      modalMsg: <p className="relay-confirm-msg">Are you sure you want to {state ? "unlock" : "lock"} this vehicle ?</p>,
      onModalClose: () => setPopUpModal(null),
      closeBtn: "Cancel",
      confirmBtn: state ? "Unlock" : "Lock",
      onConfirm: () => requestRelayToggle(state),
      footer: "relay-confirm-modal",
    });
  }

  const renderRelayButton = (currentState, updateClasses, showConfirmModal) => {
    if (!currentState) currentState = relayState;
    return (
      <div className={`relay-current-state-modal ${(currentState) ? "fill-lock-icon" : "fill-unlock-icon"} ${updateClasses ? "shrink-component" : ""}`}>
        {!updateClasses ? <p>Current status: {(currentState) ? "Locked" : "Unlocked"}</p> : null}
        <div className={`toggle-container ${(currentState) ? " locked" : " unlocked"} ${updateClasses ? "remove-margin" : ""}`}>
          <div className={!(currentState) ? "active-unlock" : "inactive-icon"}>
            <UnlockIcon className="cursor-pointer" onClick={() => showConfirmModal ? handleConfirmModal((currentState)) : handleRelayToggle((currentState), true)} />
            <h2>Unlock</h2>
          </div>
          <Tooltip placement="bottom" gutter={30} label={devAndVehicleDetails.rlp ? `Awaiting ping from device. The vehicle will be ${relayState ? "locked" : "unlocked"} once the device is online` : ""}>
            <Switch size='lg' isChecked={(currentState)} onChange={() => showConfirmModal ? handleConfirmModal((currentState)) : handleLockUnlockTest((currentState))} className={`${(currentState) ? "toggle-lock" : "toggle-unlock"} ${devAndVehicleDetails.rlp ? "show-thumb-icon" : ""}`} />
          </Tooltip>
          <div className={(currentState) ? "active-lock" : "inactive-icon"}>
            <LockIcon className="cursor-pointer" onClick={() => showConfirmModal ? handleConfirmModal((currentState)) : handleRelayToggle((currentState))} />
            <h2>Lock</h2>
          </div>
        </div>
      </div>
    );
  }

  const handlePerformSignalTest = () => {
    setPingTestProps({
      show: true,
      currentStep: PING_TEST_STEPS.IN_PROGRESS,
      progressMsg1: "Network Test in Progress",
      progressMsg2: "Checking signal strength for optimal performance..."
    })
    reqForSignalStrength();
  }

  const handleSimActivationFailure = (message = "Something went wrong, please try again later!") => {
    clearSimActivationPolling();
    simActivationInProgress.current = false;
    setPingTestProps({ show: false });
    setCustomModal({
      open: true,
      closeBtn: "Close",
      onModalClose: () => setCustomModal(null),
      modalBody: (
        <div className="ping-test-result">
          <p>{message}</p>
        </div>
      ),
    });
  }

  const startPingTestWithSimActivation = (continuePingTest) => {
    if (!ImeiRef.current || simActivationInProgress.current) return;

    clearAllTimeouts();
    clearSimActivationPolling();
    simActivationInProgress.current = true;
    setPingTestProps({
      show: true,
      currentStep: PING_TEST_STEPS.IN_PROGRESS,
      progressMsg1: "Requesting SIM activation...",
      progressMsg2: "Activating SIM...",
    });

    activateDeviceSim({ imei: Number(ImeiRef.current) }, (err) => {
      if (err) return handleSimActivationFailure("Unable to activate SIM. Please try again later.");

      const pollSimStatus = () => {
        setPingTestProps({
          show: true,
          currentStep: PING_TEST_STEPS.IN_PROGRESS,
          progressMsg1: "Waiting for SIM to become active...",
          progressMsg2: "Checking SIM status. Please keep the vehicle in a good network area.",
        });

        getDeviceSimStatus(Number(ImeiRef.current), (statusErr, data) => {
          if (statusErr) return handleSimActivationFailure("Unable to fetch SIM status. Please try again later.");
          if (data && data.active) {
            clearSimActivationPolling();
            simActivationInProgress.current = false;
            continuePingTest();
            return;
          }

          setPingTestProps({
            show: true,
            currentStep: PING_TEST_STEPS.IN_PROGRESS,
            progressMsg1: "Waiting for SIM to become active...",
            progressMsg2: data && data.status ? `Current SIM status: ${data.status}` : "Checking SIM status. Please wait...",
          });
        });
      };

      pollSimStatus();
      simActivationPollRef.current = setInterval(pollSimStatus, 10 * 1000);
    });
  }

  const handleStartPingTest = () => {
    startPingTestWithSimActivation(handlePerformSignalTest);
  }

  const handleInternalRelayRequests = (resp) => {
    const isFuelCutSuccess = resp.includes("Cut off the fuel supply: Success!") || resp.includes("Already in the state of fuel supply cut off, the command is not running!");
    const isFuelRestoreSuccess = resp.includes("Restore fuel supply: Success!") || resp.includes("Already in the state of fuel supply to resume, the command is not running!");

    const updateProgressAndCheckCompletion = (successMessage) => {
      internalRelayTestCounter.current += 1;
      if (internalRelayTestCounter.current >= 3) {
        internalRelayTestStarted.current = false;
        internalRelayTestCounter.current = 0;
        setCircularProgress(100);
        setTimeout(() => {
          setCircularProgress(0);
          onLiteCmdResp(successMessage, true);
        }, 1000);
        return true;
      }

      if (circularProgress !== 100) {
        setCircularProgress(internalRelayTestCounter.current * 33);
      }
      return false;
    };

    const handleTest = (expectedIgnitionState, vehStat, callback) => {
      const diff = (Date.now() - devAndVehDetails.current.installationDetails.receivedTs) / 1000;
      const isDataRecent = diff > -1 && diff <= 15;

      if (
        isDataRecent &&
        devAndVehDetails.current &&
        devAndVehDetails.current.installationDetails &&
        devAndVehDetails.current.installationDetails.ignition === expectedIgnitionState
      ) {
        const randomDelay = Math.floor(Math.random() * (5000 - 1000 + 1)) + 1000;
        setTimeout(callback, randomDelay);
      } else {
        ignoreRelayResponse.current = true;
        handleLockUnlockTest(true);
        setPingTestProps({
          hideClose: true,
          still: true,
          show: true,
          currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN,
          showInfo: true,
          ign: devAndVehDetails.current.installationDetails.ignition,
          vehStat,
          allowRetry: !(relayRetryCounter.current >= 3),
          retryCount: relayRetryCounter.current,
        });
      }
    };

    if (isFuelCutSuccess) {
      if (updateProgressAndCheckCompletion("Cut off the fuel supply: Success!")) return;
      setTimeout(() => { handleTest(IGNITION_STATE.OFF, 1, () => handleLockUnlockTest(true)); setRelayState(RELAY_STATES.LOCKED); }, 5000);
    } else if (isFuelRestoreSuccess) {
      if (updateProgressAndCheckCompletion("Restore fuel supply: Success!")) return;
      setTimeout(() => { handleTest(IGNITION_STATE.ON, 0, () => handleLockUnlockTest(false)); setRelayState(RELAY_STATES.UNLOCKED); }, 5000);
    } else {
      handleLockUnlockTest(true);
    }
  };

  function normalizeRelayResponse(resp) {
    if (resp.includes("RELAY:ON")) return "RELAY:1";
    else if (resp.includes("RELAY:OFF")) return "RELAY:0";

    return resp;
  }

  const onLiteCmdResp = (resp, addTimer) => {
    if (!resp) return;

    let responseString = resp;
    let explicitRelayState = null;
    // Handle new JSON response format
    if (typeof resp === 'object' && resp.respTyp === 'RELAY') {
      responseString = resp.resp;
      if (typeof resp.rlyState === 'number') explicitRelayState = resp.rlyState;
    }

    if (ignoreRelayResponse.current) {
      setPingTestProps({
        hideClose: true,
        still: true,
        show: true,
        currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN,
        showInfo: true,
        ign: devAndVehDetails.current.installationDetails.ignition,
        vehStat: 0,
        allowRetry: !(relayRetryCounter.current >= 3),
      });
      setRelayState(RELAY_STATES.UNLOCKED);
      return setEnableRelayRetry(true);
    }

    let currentState = false;
    let extVoltMatch = responseString.match(/Vext=([\d.]+)V/);

    if (extVoltMatch) {
      let vext = extVoltMatch[1];
      devAndVehDetails.current = { ...devAndVehDetails.current, installationDetails: { ...devAndVehDetails.current.installationDetails, extVolt: Number(vext) } };
      setDevAndVehicleDetails({ ...devAndVehDetails.current, installationDetails: { ...devAndVehDetails.current.installationDetails, extVolt: Number(vext) } });
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, showInfo: true, ign: 1 });
      return;
    }
    if (responseString.includes('no charge') && isIgnitionTest.current) {
      clearAllTimeouts();
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, lowVoltage: true, hideClose: true });
      return;
    }

    let signalLevelMatch = responseString.match(/(?:GSM|LTE) Signal Level:([^;]+)/);
    if (signalLevelMatch) {
      let gsmSignalLevel = signalLevelMatch ? signalLevelMatch[1].trim() : null;
      if (gsmSignalLevel === GSM_SIGNAL_LEVELS.STRONG || gsmSignalLevel === GSM_SIGNAL_LEVELS.GOOD) {
        if (global.WS && global.WS.wsConnected) {
          unlockViaStatusCheck.current = true;
          global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, command: "RELAY#" } });
        }
      }
      else setPingTestProps({ show: true, lowNetwork: true, currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN })
      return;
    }

    if (isPostMappingLockReq.current) {
      let relayResp = relayState;
      if (responseString.includes('Restore fuel supply: Success!')) relayResp = 0;
      else if (responseString.includes('Cut off the fuel supply: Success!')) relayResp = 1;
      else {
        return setPopUpModal({
          open: true,
          modalMsg: <span className="err-msg">{`Unable to ${relayResp ? "Unlock" : "Lock"} vehicle at the moment. Please try again later`}</span>,
          closeBtn: "Close",
          onModalClose: () => {
            isPostMappingLockReq.current = false;
            setPopUpModal({});
            setCustomModal({});
          },
        });
      }

      setRelayState(relayResp);
      return setPopUpModal({
        open: true,
        modalMsg: <span className="lock-unlock-success-msg">{`Vehicle has been ${relayResp ? "locked" : "unlocked"} successfully.`}</span>,
        closeBtn: "Close",
        onModalClose: () => {
          isPostMappingLockReq.current = false;
          setPopUpModal({});
          setCustomModal({});
        },
      });
    }

    responseString = normalizeRelayResponse(responseString);
    if (!isRelayTest.current) {
      if (responseString.includes('RELAY:')) {
        if (unlockViaStatusCheck.current) {
          let relayState;
          if (explicitRelayState !== null) relayState = explicitRelayState;
          else relayState = parseInt(responseString.split(':')[1]);

          if (relayState === RELAY_STATES.LOCKED) handleLockUnlockTest(true);
          else if (!devAndVehDetails.current.installationDetails.ptStat) handlePerformTest();
        }
      }
      else if (responseString.includes('Restore fuel supply: Success!')) {
        if (unlockViaStatusCheck.current) {
          if (!devAndVehDetails.current.installationDetails.ptStat) handlePerformTest();
          unlockViaStatusCheck.current = false;
        }
      }
      else if (responseString.includes("Device unreachable")) {
        setPopUpModal({
          open: true,
          modalMsg: <span className="err-msg">{responseString}</span>,
          closeBtn: "Close",
          onModalClose: () => {
            clearAllTimeouts();
            setPopUpModal({});
            setPingTestProps({});
          }
        })
      }
      return;
    }

    if (internalRelayTestStarted.current && internalRelayTestCounter.current <= 3) {
      handleInternalRelayRequests(responseString);
      return;
    }

    if (responseString.includes('RELAY:')) {
      let relayState;
      if (explicitRelayState !== null) relayState = explicitRelayState;
      else relayState = parseInt(responseString.split(':')[1]);

      currentStateRef.current = !!relayState;
      currentState = !!relayState;
      setRelayState(relayState);

      if (!profile.oldRelayFlow) {
        relayHash.current = true;
        clearAllTimeouts();
        if (relayState === 1 && devAndVehDetails.current.installationDetails && devAndVehDetails.current.installationDetails.ignition === IGNITION_STATE.ON) {
          setPingTestProps({ still: true, show: true, currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN, showInfo: true, ign: !relayState ? 1 : 0, mismatch: true, vehStat: relayState });
        }
        else {
          setPingTestProps({
            show: true, currentStep: PING_TEST_STEPS.RELAY_TEST, showInfo: true, ign: !relayState ? 1 : 0, handleRelayTest: () => {
              internalRelayTestStarted.current = true;
              setPingTestProps({ circular: true, show: true, showInfo: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Testing Immobilisation...", progressMsg2: "Good things take a little time. We're almost there!" });
              handleLockUnlockTest(relayState ? true : false)
            }, vehStat: relayState
          });
        }
      }
      else {
        if (isRelayLoading.current) {
          if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.SET_CURRENT_RLS, data: { imei: ImeiRef.current, rls: relayState } });
          isRelayLoading.current = false;
          setRelayLoading(false);
          setRelayState(currentState);
          return;
        }

        RELAY_TEST_STEPS_MAP.current["state"] = relayState ? 1 : 0;
        RELAY_TEST_STEPS_MAP.current["button"] = relayState ? "Test Unlocking" : "Test Locking";
        if (global.WS) RELAY_TEST_STEPS_MAP.current["onClick"] = () => handleLockUnlockTest(relayState ? true : false);
      }
    }
    else if (responseString.includes('Cut off the fuel supply: Success!') || responseString.includes("Already in the state of fuel supply cut off, the command is not running!")) {
      currentStateRef.current = true;
      currentState = true;
      setRelayState(RELAY_STATES.LOCKED);
      testStatus.current = { ...testStatus.current, lock: true };

      if (!profile.oldRelayFlow) {
        const handleSuccessModal = () => {
          if (devAndVehDetails.current?.installationDetails && !devAndVehDetails.current?.installationDetails.ignition) {
            clearAllTimeouts();
            setPingTestProps({
              show: true,
              currentStep: PING_TEST_STEPS.RELAY_TEST,
              showInfo: true,
              ign: 0,
              handleRelayTest: () => {
                internalRelayTestStarted.current = true;
                setPingTestProps({ circular: true, show: true, showInfo: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Testing Immobilisation...", progressMsg2: "Good things take a little time. We're almost there!" });
                handleLockUnlockTest(true);
              },
              vehStat: 1,
            });
          }
          else {
            setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Vehicle immobilised, waiting for Ignition OFF" });
            addTimeout(() => {
              setPingTestProps({ still: true, show: true, currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN, showInfo: true, ign: 1, mismatch: true, vehStat: 1 });
            }, PINGTEST_TIMEOUT_DURATION)
          }
        }
        if (addTimer) {
          setTimeout(() => {
            handleSuccessModal();
          }, 5000)
        } else handleSuccessModal();
      }
      else {
        RELAY_TEST_STEPS_MAP.current["state"] = 1;
        RELAY_TEST_STEPS_MAP.current["button"] = "Test Unlocking";
        if (global.WS) RELAY_TEST_STEPS_MAP.current["onClick"] = () => handleLockUnlockTest(true);
      }
    }
    else if (responseString.includes('Restore fuel supply: Success!') || responseString.includes("Already in the state of fuel supply to resume, the command is not running!")) {
      currentStateRef.current = false;
      currentState = false;
      setRelayState(RELAY_STATES.UNLOCKED);
      testStatus.current = { ...testStatus.current, unlock: true };

      if (!profile.oldRelayFlow) {
        const handleSuccessModal = () => {
          if (devAndVehDetails.current.installationDetails && devAndVehDetails.current.installationDetails.ignition) {
            clearAllTimeouts();
            setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.RELAY_TEST, showInfo: true, ign: 1, relayTestCompleted: true, handleRelayTest: () => unsubscribeAndCloseModal(currentStateRef.current), vehStat: 0 });
          }
          else {
            setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Vehicle mobilised, waiting for Ignition ON" });
            addTimeout(() => {
              setPingTestProps({ still: true, show: true, currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN, showInfo: true, ign: 0, mismatch: true, vehStat: 0 });
            }, PINGTEST_TIMEOUT_DURATION)
          }
        }

        if (addTimer) {
          setTimeout(() => {
            handleSuccessModal();
          }, 5000)
        } else handleSuccessModal();
      }
      else {
        RELAY_TEST_STEPS_MAP.current["state"] = 0;
        RELAY_TEST_STEPS_MAP.current["button"] = "Test Locking";
        if (global.WS) RELAY_TEST_STEPS_MAP.current["onClick"] = () => handleLockUnlockTest(false);
      }
    } else {
      if (isRelayLoading.current) {
        setRelayLoading(false);
        isRelayLoading.current = false;
        setRelayError(responseString);
      }
      if (devAndVehicleDetails && devAndVehicleDetails.dm) return;

      handleLockUnlockTest(true);
      return setPopUpModal({
        open: true,
        modalMsg: <span className="err-msg">{responseString}</span>,
        closeBtn: "Close",
        onModalClose: () => {
          clearAllTimeouts();
          setPopUpModal({});
          setPingTestProps({});
        }
      });
    }

    if (testStatus.current.lock && testStatus.current.unlock && !currentStateRef.current) {
      RELAY_TEST_STEPS_MAP.current["button"] = "Mark test complete";
      RELAY_TEST_STEPS_MAP.current["onClick"] = () => unsubscribeAndCloseModal(currentStateRef.current);
    }

    if (profile.oldRelayFlow) {
      isRelayTest.current = false;
      setPingTestProps({ show: false });
    }

    if (devAndVehDetails.current && devAndVehDetails.current.dm) {
      setCustomModal({
        open: true,
        startBtn: "Okay",
        onStart: () => setCustomModal({ open: false }),
        onModalClose: () => { },
        modalBody: (
          <div className={`lock-unlock-success-modal ${currentState ? "locked" : "unlocked"}`}>
            {currentState ? <LockIcon /> : <UnlockIcon />}
            <p className="lock-unlock-success-msg">This vehicle is now {currentState ? "locked" : "unlocked"}</p>
          </div>
        ),
      });
    } else if (profile.oldRelayFlow) {
      setCustomModal({
        open: true,
        startBtn: RELAY_TEST_STEPS_MAP.current["button"],
        onStart: RELAY_TEST_STEPS_MAP.current["onClick"],
        onModalClose: () => { },
        modalBody: renderRelayButton(currentState),
      });
    }
  }

  const SubscribeForTest = (src) => {
    if (global.WS && global.WS.wsConnected) {
      global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current, d: "onWsConnected" } });
      global.WS.sendRequest({ action: global.EE.EVENT_TYPES.SUBSCRIBE_FOR_WIRELESS_TESTING, data: { imei: ImeiRef.current, d: src } });
      isSubscribed.current = true;
    }
  }

  const onRelayDone = (data) => {
    setCustomModal({});

    if (data.error) {
      if (data.rlp || data.rlp === false) setDevAndVehicleDetails({ ...devAndVehDetails.current, rlp: data.rlp });
      if (data.rls || data.rls === 0) setRelayState(data.rls);

      return setPopUpModal({
        open: true,
        modalMsg: (
          <div>
            <div className="error-modal-image-container">
              {data.rlp ? <PendingClockIcon className="error-modal-clock-icon" /> : null}
              {data.rlp ? (data.rls ? <LockIcon className="error-modal-lock-icon" /> : <UnlockIcon className="error-modal-unlock-icon" />) : null}
            </div>
            <span className="err-msg">{data.rlp ? `Awaiting ping from device. The vehicle will be ${data.rls ? "locked" : "unlocked"} once the device is online.` : (data.rlp === false ? `Already in ${data.rls ? "locked" : "unlocked"} state. Your previous request to ${data.rls ? "unlock" : "lock"} the vehicle has been discarded.` : `${data.error} Please try again later.` || "Something went wrong")}</span>
          </div>
        ),
        closeBtn: "Close",
        onModalClose: () => {
          setPopUpModal({});
          setCustomModal({});
        },
      });
    }

    setRelayState(data.state);
    return setPopUpModal({
      open: true,
      modalMsg: <span className="lock-unlock-success-msg">{`Vehicle has been ${data.state ? "locked" : "unlocked"} successfully.`}</span>,
      closeBtn: "Close",
      onModalClose: () => {
        setPopUpModal({});
        setCustomModal({});
      },
    });
  }

  useEffect(() => {
    if (devAndVehicleDetails && devAndVehicleDetails.imei && wsConnected) {
      if (!devAndVehicleDetails.dm) SubscribeForTest('onWsConnected');
    }
  }, [wsConnected])

  const updateRelayState = (data) => {
    if ("rls" in data) setRelayState(data.rls);
    if ("rlp" in data) setDevAndVehicleDetails({ ...devAndVehDetails.current, rlp: data.rlp });
  }

  useEffect(() => {
    if (updatedImei !== ImeiRef.current) ImeiRef.current = updatedImei;

    getSpecificDevDetails(ImeiRef.current, (err, data) => {
      if (err) console.error(err);
      else {
        data = data[0];
        if (!data) data = {};
        data.vnm = "Ajjas";
        if (data.deliveredAt) data.deliveredTs = getLocalisedDate(data.deliveredAt, true);
        devAndVehDetails.current = data;

        data.installationDetails = {};
        if (data.instTs) data.installationDetails.instTs = data.instTs;
        if (data.ptStat) {
          data.installationDetails.ptStat = data.ptStat.st;
          data.installationDetails.ptTs = data.ptStat.ts;
          if (data.ptStat.lat) data.installationDetails.lat = data.ptStat.lat;
          if (data.ptStat.lng) data.installationDetails.lng = data.ptStat.lng;
        }

        if (data.chassisImg) data.installationDetails.chassisImg = data.chassisImg;

        if (data.rlyResp || data.rlyResp === 0) data.installationDetails.relayStat = data.rlyResp;
        if (data.rlyRespTs) data.installationDetails.relayTs = data.rlyRespTs;
        if (data.dm) {
          data.mappingTs = getLocalisedDate(data.dm, true);
          data.installationDetails.mapTs = data.dm;
        }
        else {
          SubscribeForTest('api_resp');

          delete data.installationDetails.instTs;

          delete data.ptStat;
          delete data.installationDetails.ptTs;
          delete data.installationDetails.ptStat;

          delete data.rlyResp;
          delete data.rlyRespTs;
          delete data.installationDetails.relayTs;
          delete data.installationDetails.relayStat;
        }
        if (data.rls || data.rls == 0) setRelayState(!!data.rls);

        let unstRsn = window.localStorage.getItem(UNSET_REASON_KEY);
        if (unstRsn) data.installationDetails.unstRsn = unstRsn;

        setDevAndVehicleDetails(data);
        getVehicleStats(data.vid);
      }
    });

    global.EE.addEventListener(global.EE.EVENT_TYPES.WS_DISCONNECTED, onWsDisconnected);
    global.EE.addEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
    global.EE.addEventListener(global.EE.EVENT_TYPES.LITE_CMD_RESP, onLiteCmdResp);
    global.EE.addEventListener(global.EE.EVENT_TYPES.RELAY_DONE, onRelayDone);
    global.EE.addEventListener(global.EE.EVENT_TYPES.RLS_RECIEVED, updateRelayState);

    const onUnload = () => {
      clearSimActivationPolling();
      simActivationInProgress.current = false;
      if (global.WS && global.WS.wsConnected && isSubscribed.current) {
        isSubscribed.current = false;
        global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current, d: "onunload" } });
      }
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WS_DISCONNECTED, onWsDisconnected);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.LITE_CMD_RESP, onLiteCmdResp);
      global.EE.addEventListener(global.EE.EVENT_TYPES.RELAY_DONE, onRelayDone);
      global.EE.addEventListener(global.EE.EVENT_TYPES.RLS_RECIEVED, updateRelayState);
    };

    window.onbeforeunload = function (e) {
      return onUnload();
    };

    return () => {
      onUnload();
    };
  }, [updatedImei]);

  const onWsConnected = () => {
    setWsConnected(true);
  }

  const onWsDisconnected = () => {
    setWsConnected(false);
  }

  const devDetailsKeyValues = [
    { label: "IMEI", key: "imei" },
    { label: "Shipment ID", key: "orderId" },
    { label: "Device Type", key: "btrId", constants: DEVICE_TYPES_VALS, constantsAccessor: "nm" },
    { label: "Delivery Date", key: "deliveredTs" },
    { label: "Mapping Status", key: "dm", condition: true },
    { label: "SIM", key: "spnId", constants: SPN_IDS, constantsAccessor: "nm" },
    { label: "Ping Test Status", key: "ptStat", nestedKey: "st", constants: PING_TEST_STATUS },
    { label: "Dealer Name", key: "dnm" },
  ];

  const vehDetailsKeyValues = [
    { label: "Chassis Number", key: "chNum" },
    { label: "Registration No.", key: "reg" },
    { label: "Mapping Date", key: "mappingTs" },
    { label: "Immobilisation Status", key: "rls" },
  ]

  const getValue = (detail, devAndVehicleDetails) => {
    if (detail.condition) return devAndVehicleDetails[detail.key] ? "Mapped" : "Unmapped";
    if (detail.constants) {
      let value = (detail.nestedKey && devAndVehicleDetails[detail.key]) ? (devAndVehicleDetails[detail.key])[detail.nestedKey] : devAndVehicleDetails[detail.key];
      const constantDetail = detail.constants[value];
      return (constantDetail && constantDetail[detail.constantsAccessor]) ? constantDetail[detail.constantsAccessor] : (constantDetail || "-");
    }

    return devAndVehicleDetails[detail.key];
  };

  const handlePingTestErr = () => {
    clearSimActivationPolling();
    simActivationInProgress.current = false;
    const modalData = {
      open: true,
      closeBtn: "Close",
      onModalClose: () => setCustomModal(null),
      modalBody: (
        <div className="ping-test-result">
          <p>{"Something went wrong, please try again later!"}</p>
        </div>
      ),
    };
    setPingTestProps({ show: false })
    setCustomModal(modalData);
  }

  const handleMapDevice = () => {
    if (!(devAndVehicleDetails && !devAndVehicleDetails.dm)) return;
    navigate(
      `${PATH.INVENTORY_OVERVIEW}/${PATH.MAP_TO_VEHICLE}?imei=${ImeiRef.current}`
    );
  }

  const handleEditVehicleDetails = () => {
    let url = `${liveTracking.current ? PATHS.LIVE_TRACKING : PATHS.SHOW_DEALERS}/${PATHS.SPECIFIC_DEVICE}/${PATHS.EDIT_VEHICLE_DETAILS}?imei=${ImeiRef.current}&idx=${dealerId.current}&edit=${true}${liveTracking.current ? "&liveTracking=true" : ""}`
    if (instock.current) url += `&inStock=true`;
    if (installed.current) url += `&installed=true`;
    navigate(url, {
      state: {
        vid: devAndVehicleDetails.vid,
        chNum: devAndVehicleDetails.chNum,
        reg: devAndVehicleDetails.reg,
        chassisImg: devAndVehicleDetails.chassisImg,
      }
    });
  }

  const getRelayStatus = (key, data) => {
    if (data[key] === RELAY_STATES.UNLOCKED || data[key] === RELAY_STATES.LOCKED) {
      return data[key] ? "Locked" : "Unlocked";
    }

    return "-";
  }

  const clearAllTimeouts = () => {
    timeouts.current.forEach(clearTimeout);
    timeouts.current = [];
  };

  const clearSimActivationPolling = () => {
    if (simActivationPollRef.current) {
      clearInterval(simActivationPollRef.current);
      simActivationPollRef.current = null;
    }
  };

  const addTimeout = (callback, delay) => {
    const timeout = setTimeout(callback, delay);
    timeouts.current.push(timeout);
  };

  const reqForSignalStrength = () => {
    if (global.WS && global.WS.wsConnected) {
      global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, command: "STATUS#" } });
    }
  }

  const reqForVoltageDetails = () => {
    if (global.WS && global.WS.wsConnected) {
      global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, command: "BMT#" } });
    }
  }

  const unsetPingTestStatus = (reason) => {
    UnsetPingTestStatus({ imei: ImeiRef.current }, (err, data) => {
      if (data) {
        devAndVehDetails.current = { ...devAndVehDetails.current, ptStat: {}, instTs: null, installationDetails: { unstRsn: reason, resetFlow: true } };
        setDevAndVehicleDetails({ ...devAndVehDetails.current, ptStat: {}, instTs: null, installationDetails: { unstRsn: reason, resetFlow: true } });
      }
    })
  }

  const updateResetFlow = () => {
    devAndVehDetails.current = { ...devAndVehDetails.current, ptStat: {}, instTs: null, installationDetails: { ...devAndVehDetails.current.installationDetails, resetFlow: false } };
    setDevAndVehicleDetails({ ...devAndVehDetails.current, ptStat: {}, instTs: null, installationDetails: { ...devAndVehDetails.current.installationDetails, resetFlow: false } });
  }

  const handleModalClose = () => {
    setCustomModal({
      open: true,
      closeBtn: "Cancel",
      onModalClose: () => { setCustomModal(null) },
      confirmBtn: "Close",
      onConfirm: () => {
        clearAllTimeouts();
        clearSimActivationPolling();
        simActivationInProgress.current = false;
        setPingTestProps({ show: false })
        setCustomModal(null);
        setCircularProgress(0);
        isRelayTest.current = false;
        isIgnitionTest.current = false;
        internalRelayTestStarted.current = false;
        internalRelayTestCounter.current = 0;
        relayRetryCounter.current = 0;
      },
      modalBody: (
        <div className="close-modal">
          <span><Alert /> Alert</span>
          <p>{isRelayTest.current ? "Closing this popup will discard the Immobilisation test. You'll need to restart it." : "Closing this popup will discard the ignition test. You'll need to restart it."}</p>
        </div>
      )
    })
  }

  const handleRelayRetry = () => {
    ignoreRelayResponse.current = false;
    relayRetryCounter.current += 1;
    internalRelayTestStarted.current = true;
    internalRelayTestCounter.current = 0;
    setEnableRelayRetry(false);
    setCircularProgress(0);
    setPingTestProps({ circular: true, show: true, showInfo: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Testing Immobilisation...", progressMsg2: "Good things take a little time. We're almost there!" });
    handleLockUnlockTest(!!relayState);
  }

  const handleRestartRetry = (reason = "", unsetKeys = false, retry) => {
    if (retry) {
      internalRelayTestCounter.current = 0;
      return handleRelayRetry();
    }

    handleLockUnlockTest(true);
    if (reason && ImeiRef.current) {
      if (unsetKeys) unsetPingTestStatus(reason);
      else {
        let updateValues = { ...devAndVehDetails.current, ptStat: {}, installationDetails: { unstRsn: reason } };
        delete updateValues.rlyResp;
        delete updateValues.rlyRespTs;
        devAndVehDetails.current = updateValues;
        setDevAndVehicleDetails(updateValues);
      }
      clearAllTimeouts();
      setPingTestProps({ show: false });
      isRelayTest.current = false;
      isIgnitionTest.current = false;
      window.localStorage.setItem(UNSET_REASON_KEY, reason);
    }
  }

  const handlePerformTest = () => {
    setPingTestProps({
      show: true,
      currentStep: PING_TEST_STEPS.IGN_SWITCH,
      ign: 0,
    })
  };

  const handleIgnSwitch = () => {
    if (!devAndVehDetails.current.installationDetails.ptStat) isIgnitionTest.current = true;

    if (devAndVehicleDetails?.installationDetails?.ignition && pingTestProps.showInfo) {
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Make sure ignition key is OFF and vehicle is in good network area", showInfo: true });

      addTimeout(() => {
        setPingTestProps({
          show: true,
          showInfo: true,
          currentStep: PING_TEST_STEPS.IN_PROGRESS,
          progressMsg1: "Restart the Ignition",
          progressMsg2: "Please turn the ignition ON and then back OFF, and double-check that all connections and installations are correct",
        });
      }, 10 * 1000);

      if (devAndVehicleDetails?.installationDetails?.ignition === IGNITION_STATE.OFF) {
        addTimeout(() => {
          setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, showInfo: true, ign: 0 });
        }, 1000)
        return;
      }

      addTimeout(() => {
        setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN, showInfo: true, ign: 1, still: true });
      }, PINGTEST_TIMEOUT_DURATION)
    }
    else if (devAndVehicleDetails?.installationDetails?.ignition === IGNITION_STATE.OFF && pingTestProps.showInfo) {
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Make sure ignition key is OFF and vehicle is in good network area", showInfo: true });
      addTimeout(() => {
        setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, showInfo: true, ign: 0 });
      }, 1000)
      return;
    }
    else {
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Make sure you are in good network area" });
      addTimeout(() => {
        setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.RATED_VOLT_INP });
      }, 1000);
    }
  }

  const handleRatedVoltContinue = () => {
    setPingTestProps({
      show: true,
      currentStep: PING_TEST_STEPS.IN_PROGRESS,
      progressMsg1: "Checking for the vehicle ignition and battery voltage",
      progressMsg2: "Make sure you are in good network area",
    });

    if (devAndVehicleDetails?.installationDetails?.ignition === IGNITION_STATE.ON) {
      if (!devAndVehicleDetails?.installationDetails?.extVolt) reqForVoltageDetails();
      else {
        addTimeout(() => {
          setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, showInfo: true, ign: 1 });
        }, 1000)
      }
      return;
    }

    if (isIgnitionTest.current) {
      addTimeout(() => {
        setPingTestProps({
          show: true,
          currentStep: PING_TEST_STEPS.IN_PROGRESS,
          progressMsg1: "Restart the Ignition",
          progressMsg2: "Please turn the ignition OFF and back ON, and double-check that all connections and installations are correct",
        });
      }, 10 * 1000);
    }

    addTimeout(() => {
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN, ign: 0 });
    }, PINGTEST_TIMEOUT_DURATION);
  }

  const handleIgnVerified = () => {
    setPingTestProps({
      show: true,
      currentStep: PING_TEST_STEPS.IN_PROGRESS,
      showInfo: true,
    });

    addTimeout(() => {
      setPingTestProps({
        show: true,
        currentStep: PING_TEST_STEPS.IGN_SWITCH,
        ign: 1,
        showInfo: true,
      })
    }, 1000)
  }

  const handleIgnitionTestSuccess = (inpExtVolt) => {
    setPingTestProps({ show: false });
    clearAllTimeouts();
    if (!devAndVehDetails.current.ptStat || (devAndVehDetails.current.ptStat && devAndVehDetails.current.ptStat.st !== PING_TEST_STATUS_VAL["Tested"])) {
      devAndVehDetails.current = { ...devAndVehDetails.current, ptStat: { st: PING_TEST_STATUS_VAL["Tested"], ts: Date.now() }, installationDetails: { ...devAndVehDetails.current.installationDetails, ptStat: PING_TEST_STATUS_VAL["Tested"], ptTs: Date.now(), ignition: null, unstRsn: null } };
      setDevAndVehicleDetails({ ...devAndVehDetails.current, ptStat: { st: PING_TEST_STATUS_VAL["Tested"], ts: Date.now() }, installationDetails: { ...devAndVehDetails.current.installationDetails, ptStat: PING_TEST_STATUS_VAL["Tested"], ptTs: Date.now(), ignition: null, unstRsn: null } });
      window.localStorage.removeItem(UNSET_REASON_KEY);
      internalRelayTestStarted.current = false;
      updatePingTestStatus({ imei: Number(ImeiRef.current), lat: devAndVehicleDetails?.installationDetails?.lat, lng: devAndVehicleDetails?.installationDetails?.lng, extVolt: devAndVehicleDetails?.installationDetails?.extVolt, inpExtVolt: Number(inpExtVolt) }, (err) => { });
    }
  };

  const checkIfPingTestIsCompleted = () => {
    if (profile.oldRelayFlow) {
      if (DESIGNATION === SELLER_DES) return;
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Make sure you are in good network area" });
      isRelayTest.current = true;
      if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, command: devAndVehicleDetails.rlyResp ? `RELAY,${devAndVehicleDetails.rlyResp}#` : "RELAY#" } });
    }
    else {
      isRelayTest.current = true;
      handlePerformTest()
    }
  }

  const handleStartRelayTest = () => {
    setPingTestProps({
      show: true,
      currentStep: PING_TEST_STEPS.IN_PROGRESS,
      progressMsg1: "Make sure you are in good network area",
    });
    if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, command: "RELAY#" } });

    addTimeout(() => {
      setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.UNABLE_DETECT_IGN, ign: 0 });
    }, PINGTEST_TIMEOUT_DURATION);
  }

  const handleWirelessTestingSuccess = (data) => {
    if (data) {
      if ((data.externalVolt === 0 || data.voltLvl === 0) && !devAndVehDetails.current.installationDetails.ptStat && (isIgnitionTest.current || isRelayTest.current || isRelayTestCompleted.current)) {
        clearAllTimeouts();
        isRelayTest.current = false;
        isIgnitionTest.current = false;
        setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, lowVoltage: true, hideClose: true });
        internalRelayTestStarted.current = false;
        internalRelayTestStarted.current = 0;
        setCircularProgress(0);
      }
      devAndVehDetails.current = { ...devAndVehDetails.current, installationDetails: { ...devAndVehDetails.current.installationDetails, extVolt: data.externalVolt, intVolt: data.voltLvl } };
      setDevAndVehicleDetails({ ...devAndVehDetails.current, installationDetails: { ...devAndVehDetails.current.installationDetails, extVolt: data.externalVolt, intVolt: data.voltLvl } });
    }
  }

  const handleVehicleLocationData = (data) => {
    if (data && data.lat && data.lng && (data.ignition === IGNITION_STATE.OFF || data.ignition === IGNITION_STATE.ON)) {
      if (data.spd && data.spd > 5 && ((Date.now() - (data.ts * 1000)) <= TWO_MINS_MS) && (isIgnitionTest.current || isRelayTest.current)) {
        clearAllTimeouts();
        isRelayTest.current = false;
        isIgnitionTest.current = false;
        setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, motionDetected: true, hideClose: true });
        internalRelayTestStarted.current = false;
        internalRelayTestStarted.current = 0;
        setCircularProgress(0);
        return;
      }
      if (!devAndVehicleDetails?.installationDetails?.ptStat && isIgnitionTest.current) {
        if (data.ignition === IGNITION_STATE.ON && !devAndVehicleDetails?.installationDetails?.ignition && pingTestProps.currentStep === PING_TEST_STEPS.IN_PROGRESS) {
          clearAllTimeouts();
          if (!devAndVehDetails?.current?.installationDetails?.extVolt) reqForVoltageDetails();
          else setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, showInfo: true, ign: data.ignition });
        }

        else if (data.ignition === IGNITION_STATE.OFF && devAndVehicleDetails?.installationDetails?.ignition === IGNITION_STATE.ON && pingTestProps.currentStep === PING_TEST_STEPS.IN_PROGRESS) {
          clearAllTimeouts();
          setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.IGN_DETECTED, showInfo: true, ign: data.ignition });
        }
      }
      else if (!(devAndVehicleDetails.rlyResp === 0 || devAndVehicleDetails.rlyResp === 1) && isRelayTest.current) {
        // if (data.ignition === IGNITION_STATE.ON && pingTestProps.currentStep === PING_TEST_STEPS.IN_PROGRESS && !devAndVehicleDetails?.installationDetails?.ignition) {
        //   if (testStatus.current.unlock) {
        //     clearAllTimeouts();
        //     console.log("----fired")
        //     setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.RELAY_TEST, showInfo: true, ign: 1, relayTestCompleted: true, handleRelayTest: () => unsubscribeAndCloseModal(currentStateRef.current), vehStat: 0 });
        //   }
        // }

        // if (data.ignition === IGNITION_STATE.OFF && pingTestProps.currentStep === PING_TEST_STEPS.IN_PROGRESS && devAndVehicleDetails?.installationDetails?.ignition) {
        //   if (testStatus.current.lock) {
        //     clearAllTimeouts();
        //     console.log('fired 2');
        //     setPingTestProps({ show: true, currentStep: PING_TEST_STEPS.RELAY_TEST, showInfo: true, ign: 0, handleRelayTest: () => {
        //       internalRelayTestStarted.current = true;
        //       setPingTestProps({ circular: true, show: true, currentStep: PING_TEST_STEPS.IN_PROGRESS, progressMsg1: "Testing Immobilisation...", progressMsg2: "Good things take a little time. We're almost there!" });
        //       handleLockUnlockTest(true);
        //     }, vehStat: 1});
        //   }
        // }
      }
      devAndVehDetails.current = { ...devAndVehDetails.current, installationDetails: { ...devAndVehDetails.current.installationDetails, lat: data.lat, lng: data.lng, ignition: data.ignition, ts: data.ts, receivedTs: Date.now(), spd: data.spd } };
      setDevAndVehicleDetails(devAndVehDetails.current);
    }
  }

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.ON_VEHICLE_DATA, handleVehicleLocationData);
    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.ON_VEHICLE_DATA, handleVehicleLocationData);
    }
  }, [pingTestProps]);

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.WIRELESS_TESTING_SUCCESSFULL, handleWirelessTestingSuccess);
    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WIRELESS_TESTING_SUCCESSFULL, handleWirelessTestingSuccess);
    }
  }, [devAndVehicleDetails]);

  useEffect(() => {
    if (!pingTestProps.circular) return;
    let intervaltimeout = setInterval(() => {
      if (!pingTestProps.circular) return clearInterval(intervaltimeout);
      setPingTestProps((prev) => ({
        ...prev,
        progressMsg1: prev.progressMsg1 === "Please Don't Turn OFF your Vehicle!" ? "Testing Immobilisation..." : "Please Don't Turn OFF your Vehicle!",
      }))
    }, 5 * 1000)
    return () => clearInterval(intervaltimeout);
  }, [pingTestProps.circular]);

  const getVehicleStats = (vehicleId) => {
    getDriverOrVehicleStats(vehicleId, null, null, (err, resp) => {
      if (err) console.error(err);
      else setVehicleStats(resp.dayWiseStats);
    });
  }

  return (
    <div className="specific-order">
      <div className="breadcrumb-container">
        <Breadcrumb paths={getPaths()} />
      </div>

      {(showButtons && isLiveTrackingEnabled && devAndVehDetails.current.vid) ? <div className="seller-view-btns-container">
        {DESIGNATION === SELLER_DES ? <Button className="seller-view-stats-btn" variant={"outline"} onClick={() => navigate(`${liveTracking.current ? PATHS.LIVE_TRACKING : PATHS.ALL_VEHICLE_STATS}/${PATHS.SINGLE_VEHICLE_STATS}?idx=${devAndVehicleDetails.vid}&isSvs=true${filters.range ? `&range=${filters.range}` : ""}${liveTracking.current ? '&liveTracking=true' : ""}`)}>View Statistics</Button> : null}
        <Button className="seller-view-rides-btn" variant={"outline"} onClick={() => navigate(`${PATHS.LIVE_TRACKING}/${PATHS.PAST_RIDES}/${devAndVehicleDetails.vid}?reg=${devAndVehicleDetails.reg}${filters.range ? `&range=${filters.range}&imei=${devAndVehicleDetails.imei}${liveTracking.current ? '&liveTracking=true' : ""}` : ""}`)}>View Rides</Button>
      </div> : null}

      <div className="details-container">
        <div className="device-details detail">
          <div className={`title-container ${subscriptionExpiry.current ? 'has-expiry-tag' : ''}`}>
            <Title>Device Details</Title>
            {subscriptionExpiry.current && (() => {
              const sed = parseInt(subscriptionExpiry.current);
              const now = Date.now();
              const daysToExpiry = Math.ceil((sed - now) / (24 * 60 * 60 * 1000));
              return (
                <span className="subscription-expiry-tag">
                  Expiring in next {daysToExpiry} days
                </span>
              );
            })()}
          </div>
          <div className="info">
            {devDetailsKeyValues.map(detail => (
              <p key={detail.key}>
                <span className="key">{detail.label}:</span>
                <span className="value">{getValue(detail, devAndVehicleDetails)}</span>
              </p>
            ))}
          </div>
        </div>
        {devAndVehicleDetails.dm && <div className="vehicle-details detail">
          <div className="title-container">
            <div className="tb-cnt">
              <Title>Vehicle Details</Title>
              {
                DESIGNATION === SELLER_DES
                  ? <Button className="edit-btn" onClick={handleEditVehicleDetails}> <EditModelIcon /> Edit </Button>
                  : null
              }
            </div>
            {(SHOW_RELAY_CONTROL_BTN && (DESIGNATION === SELLER_DES || DESIGNATION === SUBDEALERS_DES) && !relayLoading && !relayError) ? renderRelayButton(null, true, true) : (!relayError && SHOW_RELAY_CONTROL_BTN ? <Spinner /> : null)}
          </div>
          <div className="info vehicle-details">
            {vehDetailsKeyValues.map(detail => {
              let isRls = detail.key === "rls";
              if (isRls && DESIGNATION !== SUBDEALERS_DES) return "";

              return (
                <p key={detail.key}>
                  <span className="key">{detail.label}:</span>
                  <span className="value">{isRls ? getRelayStatus(detail.key, devAndVehicleDetails) : (devAndVehicleDetails[detail.key] || "-")}</span>
                </p>
              )
            })}
          </div>
        </div>}
      </div>

      <div className="installation-detail-container">
        <LastOrder
          key={devAndVehicleDetails.imei}
          showOrderDetails={false}
          isOverviewPage={false}
          isInstallationDetails={true}
          installationDetails={devAndVehicleDetails?.installationDetails}
          devAndVehicleDetails={devAndVehicleDetails}
          handleMapDevice={handleMapDevice}
          checkIfPingTestIsCompleted={checkIfPingTestIsCompleted}
          handlePerformPingTest={handleStartPingTest}
          updateResetFlow={updateResetFlow}
        />
      </div>
      {devAndVehicleDetails && devAndVehicleDetails.vid && isLiveTrackingEnabled ? <div className="specific-dev-today-ride">
        <TodayRide singleDevPage={true} vid={devAndVehicleDetails.vid} vehicleDetails={devAndVehicleDetails} devType={DEVICE_HWTYPS.Lite} vehicleStats={vehicleStats} />
      </div> : null}

      <PopUpModal {...popUpModal} />
      <CustomPopUpModal {...customModal} />

      <PingTest
        key={pingTestProps}
        handleModalClose={handleModalClose}
        imei={ImeiRef.current}
        handlePingTestErr={handlePingTestErr}
        handleIgnSwitch={handleIgnSwitch}
        handleRatedVoltContinue={handleRatedVoltContinue}
        devAndVehicleDetails={devAndVehicleDetails}
        handleIgnVerified={handleIgnVerified}
        handlePerformTest={handlePerformTest}
        handleIgnitionTestSuccess={handleIgnitionTestSuccess}
        handleStartRelayTest={handleStartRelayTest}
        relayTestStarted={isRelayTest.current}
        handleRestartRetry={handleRestartRetry}
        handlePerformSignalTest={handlePerformSignalTest}
        circularProgress={circularProgress}
        enableRelayRetry={enableRelayRetry}
        {...pingTestProps}
      />
    </div>
  );
};

export default SpecificDeviceNew;
